module.exports = __webpack_public_path__ + "img/result_vote_btn.0e9c4c87.png";